/* LUS · About: before/after sliders. Pointer, keyboard and touch. */
(function () {
  'use strict';

  function wire(box) {
    if (box.dataset.lusCmp === '1') return;
    box.dataset.lusCmp = '1';

    function set(pct) {
      var v = Math.max(0, Math.min(100, pct));
      box.style.setProperty('--x', v + '%');
      box.setAttribute('aria-valuenow', Math.round(v));
    }

    function fromEvent(e) {
      var r = box.getBoundingClientRect();
      var x = (e.clientX !== undefined ? e.clientX : (e.touches && e.touches[0].clientX)) - r.left;
      set((x / r.width) * 100);
    }

    var dragging = false;
    box.addEventListener('pointerdown', function (e) {
      dragging = true;
      box.setPointerCapture(e.pointerId);
      fromEvent(e);
    });
    box.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      fromEvent(e);
    });
    ['pointerup', 'pointercancel'].forEach(function (t) {
      box.addEventListener(t, function () { dragging = false; });
    });

    // hovering alone is enough to explore it on desktop
    box.addEventListener('pointermove', function (e) {
      if (dragging || e.pointerType !== 'mouse') return;
      fromEvent(e);
    });

    box.setAttribute('role', 'slider');
    box.setAttribute('tabindex', '0');
    box.setAttribute('aria-valuemin', '0');
    box.setAttribute('aria-valuemax', '100');
    set(50);

    box.addEventListener('keydown', function (e) {
      var cur = parseFloat(box.style.getPropertyValue('--x')) || 50;
      if (e.key === 'ArrowLeft') { e.preventDefault(); set(cur - 4); }
      if (e.key === 'ArrowRight') { e.preventDefault(); set(cur + 4); }
      if (e.key === 'Home') { e.preventDefault(); set(0); }
      if (e.key === 'End') { e.preventDefault(); set(100); }
    });
  }

  function bind() { document.querySelectorAll('.ab-cmp').forEach(wire); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
